import * as qs from "query-string";
import { ClientOptions, ClientJson } from "../types";

export class ClientOptionsValidator {
  static isValid(options: ClientOptions): boolean {
    return !!(options.ProjectId && options.ModelId);
  }
}

export const parseQueryParameters = (client: ClientJson): ClientOptions => {
  const query = qs.parse(window.location.search);

  const options: ClientOptions = {
    LaunchType: (query["launchType"] as string) ?? client.launchType,
    Endpoint: (query["endpoint"] as string) ?? client.endpoint,
    ProjectId: (query["projectId"] as string) ?? client.projectId,
    ModelId: (query["modelId"] as string) ?? client.modelId,
    Version: (query["version"] as string) ?? client.version,
    EnvironmentId: (query["environmentId"] as string) ?? client.environmentId,
    UsePointerLock:
      (query["usePointerLock"] === undefined
        ? client.usePointerLock
        : query["usePointerLock"] === "true") ?? true,
    PointerLockRelease:
      (query["pointerLockRelease"] === undefined
        ? client.pointerLockRelease
        : query["pointerLockRelease"] === "true") ?? true,
    ForceRelay:
      typeof query["forceRelay"] !== "undefined" &&
      query["forceRelay"] !== null,
    UseNativeTouchEvents:
      typeof query["useNativeTouchEvents"] !== "undefined" &&
      query["useNativeTouchEvents"] !== null,
  };

  return options;
};

export const extractBlobNameFromUrl = (url: string): string => {
  try {
    const urlParts = url.split("/");
    return urlParts[urlParts.length - 1];
  } catch (err) {
    console.error("Error extracting blob name from URL: ", err);
    return "";
  }
};

export const initializeAudio = (volume: number = 0.5): HTMLAudioElement => {
  const audio = new Audio();
  audio.autoplay = true;
  audio.volume = volume;
  return audio;
};
